function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    hamburger\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.41,9.54H3.59a1.63,1.63,0,0,1,0-3.25H36.41a1.63,1.63,0,0,1,0,3.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.41,21.62H3.59a1.63,1.63,0,0,1,0-3.25H36.41a1.63,1.63,0,0,1,0,3.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.41,33.71H3.59a1.63,1.63,0,0,1,0-3.25H36.41a1.63,1.63,0,0,1,0,3.25Z",
  fill: "#231f20"
});

function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgHamburger;